export default __webpack_public_path__ + "static/media/Helm of the Oxmal.6fd28402.jpg";